const mutationTypes = {
  SET_DISPOSE: 'dispose',
  SET_ACADEMIC_YEARS: 'setAcademicYears',
  SET_MONTHS: 'setMonths',
  SET_CENTERS: 'setCenters',
  SET_PROVIDERS: 'setProvider',
  SET_PROVIDERS_SERVICE_TYPE: 'setProviderServiceType',
  SET_STATUS: 'setStatus',
  SET_BILLING_SEARCH_RESULT: 'setBillingSearchResult',
  SET_BILLING_FILTER: 'setBillingFilter',
  SET_BILLING_SERVICE_DETAILS: 'setBillingServiceDetails',
  SET_BILLING_SERVICE_DETAILS_PAGINATION: 'setBillingServiceDetailsPagination',
  SET_BILLING_SERVICE_DETAILS_INFO: 'setBillingServiceDetailsInfo',
  SET_VISIT_DETAILS: 'setVisitdetails',
  SET_BILLING_ADDITIONAL_INFO: 'setBillingAdditionalInfo',
  SET_BILLING_ADDITIONAL_INFO_VISIT_CERT: 'setBillingAdditionalInfoVisitCert',
  SET_BILLING_VISIT_CERT_DOCUMENT_TYPES: 'setBillingVisitCertDocumentTypes',
  SET_UPLOAD_VISIT_CERT_DOCUMENT: 'setUploadVisitCertDocument',
  SET_BILLING_ADJUSTMENTS_DETAILS: 'setBillingAdjustmentsDetails',
  SET_BILLING_STATUS_TRANSITION: 'setBillingStatusTransition',
  SET_BILLING_DETAILS_SERVICE_TYPE: 'setBillingDetailsServiceType',
  SET_BILLING_DETAILS_DISCIPLINE: 'setBillingDetailsDiscipline',
  SET_BILLING_DETAILS_SPECIALIST: 'setBillingDetailsSpecialist',
  SET_BILLING_DETAILS_FILTER: 'setBillingDetailsFilter',
  SET_CATALOG: 'setCatalog',
  SET_CHECK_UNCHECK_FLAG_SERVICE_DETAIL: 'setCheckUncheckFlagServiceDetail',
  SET_BILLING_TRACKING: 'setBillingTracking',
  SET_BILLING_ADJUSTMENTS_DETAILS_LIST: 'setBillingAdjustmentsDetailsList',
  SET_BILLING_ADJUSTMENT_OBJECTION: 'setBillingAdjustmentObjection',
  SET_BILLING_SERVICE_ADJUSTMENTS: 'setBillingServiceAdjustments',
  SET_VISITS: 'setVisits',
  SET_REASONS: 'setReasons',
  SET_SERVICE_ADJUSTMENT_PAGING: 'setServiceAdjustmentPaging',
  SET_SERVICE_TYPES: 'setServiceTypes',
  SET_INTERVENTORS: 'setInterventors',
};

export default mutationTypes;
